import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  store_name: "Victory General Store",
  whatsapp_number: "",
  currency_symbol: "₹",
  logo_url: "",
  contact_address: "",
  contact_phone: "",
  contact_email: "",
  footer_text: "",
  hero_enabled: true,
  hero_title: "",
  hero_subtitle: "",
  hero_image_url: "",
  show_category_grid: true,
  promo_enabled: false,
  promo_title: "",
  promo_subtitle: "",
  promo_image_url: "",
  promo_link: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [categories, setCategories] = useState([]);
  const [pages, setPages] = useState([]);
  const [banners, setBanners] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    const [s, c, p, b] = await Promise.allSettled([
      api.get("/settings"),
      api.get("/categories"),
      api.get("/pages"),
      api.get("/banners"),
    ]);
    if (s.status === "fulfilled") setSettings({ ...DEFAULTS, ...s.value.data });
    if (c.status === "fulfilled") setCategories(c.value.data);
    if (p.status === "fulfilled") setPages(p.value.data);
    if (b.status === "fulfilled") setBanners(b.value.data);
    setLoaded(true);
  };

  useEffect(() => {
    refresh();
  }, []);

  const currency = settings.currency_symbol || "₹";

  const labelMap = {};
  categories.forEach((c) => {
    labelMap[c.key] = c.label;
    (c.subcategories || []).forEach((s) => (labelMap[s.key] = s.label));
  });
  const labelFor = (k) => labelMap[k] || k;

  const navPages = pages.filter((p) => p.in_nav);
  const footerPages = pages.filter((p) => p.in_footer);

  // Build nested category tree from parent_id
  const byId = {};
  categories.forEach((c) => (byId[c.id] = { ...c, children: [] }));
  const roots = [];
  categories.forEach((c) => {
    const node = byId[c.id];
    if (c.parent_id && byId[c.parent_id]) byId[c.parent_id].children.push(node);
    else roots.push(node);
  });
  const categoryTree = roots.sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <SettingsContext.Provider
      value={{ settings, categories, categoryTree, pages, banners, navPages, footerPages, currency, labelFor, refresh, loaded }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
